import { render } from "./GerenciarIESubstituicaoTributariaModal.vue?vue&type=template&id=36bbbcbe&ts=true"
import script from "./GerenciarIESubstituicaoTributariaModal.vue?vue&type=script&lang=ts"
export * from "./GerenciarIESubstituicaoTributariaModal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__